import { Typography } from "@mui/material";
import { ColumnDirectionJustifyCenterAlignCenterFlexFill } from "../commons/Containers";

export default function NotFound() {
    return (
        <ColumnDirectionJustifyCenterAlignCenterFlexFill>
            <Typography variant="h4">
                Not found
            </Typography>
        </ColumnDirectionJustifyCenterAlignCenterFlexFill>
    );
}